import wix from '../services/wix';
import { AVAILABILITY_STATUS } from '@wix/chat-web';
import { lazyLoaders } from '../services/loading-scheduler';

export const getChatState = ({ requestId }: { requestId: string }) => {
  return async function (dispatch, getState) {
    const requestName = 'ChatWidget.getChatState';
    const responseEventName = `${requestName}Response.${requestId}`;
    try {
      const chatrooms = await new Promise(async (resolve) => {
        const lazySdk = await lazyLoaders.interactivity.chatSdk();
        return lazySdk.chatSdk.subscribeToChatRoomsList({
          callback: ({ rooms }) => rooms && resolve(rooms),
        });
      });

      wix.publishToPubSub(responseEventName, {
        success: true,
        results: {
          isWidgetCollapsed: !getState().widgetExpanded,
          isWidgetExpanded: getState().widgetExpanded,
          isWidgetAvailable:
            getState().availabilityStatus === AVAILABILITY_STATUS.AVAILABLE,
          isWidgetAllowInput: getState().allowInput,
          isWidgetHasMessages: getState().hasMessages,
          wasWidgetExpanded: getState().everExpanded,
          wasWidgetLeadCaptureFormFilled: getState().wasLeadCaptureFormFilled,
          currentChatroom: getState().currentChatroom
            ? getState().currentChatroom.id
            : null,
          businessChatroom: getState().businessChatRoomId,
          chatrooms,
        },
      });
    } catch (e) {
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
